// extracted by css-extract-rspack-plugin
export default {"sankeyRoot":"sankeyRoot-JbTCTa","sankeyBody":"sankeyBody-ceJdTt","sankeyBodyWithFooter":"sankeyBodyWithFooter-cU0Wue"};